import moment from 'moment';

const VerifyHistoryColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 70
  },
  {
    title: 'Webpage Name',
    dataIndex: 'webpageName',
    width: 250
  },
  {
    title: 'Webpage URL',
    dataIndex: 'webpageUrl',
    slot: 'webpageUrl',
    width: 250
  },
  {
    title: 'Verify Date/Time',
    dataIndex: 'verifyAt',
    slot: 'verifyAt',
    width: 200,
    sorter: (a, b) => moment(a.verifyAt).diff(moment(b.verifyAt)),
  },
  {
    title: 'Result',
    dataIndex: 'resultStatus',
    slot: 'resultStatus',
    width: 100,
    sorter: (a, b) => a.resultStatus.localeCompare(b.resultStatus)
  },
  {
    title: '',
    dataIndex: '',
    width: 150,
    slot: 'operation'
  }
];

export { VerifyHistoryColumn };
